import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ServerService } from '../services/server.service';

// import { CdTimerComponent } from 'angular-cd-timer';
import Swal from 'sweetalert2'

declare var $:any;

declare var iziToast:any;
@Component({
  selector: 'app-custom-wallboard-five',
  templateUrl: './custom-wallboard-five.component.html',
  styleUrls: ['./custom-wallboard-five.component.css']
})
export class CustomWallboardFiveComponent implements OnInit {
 

  // @ViewChild( 'basicTimer', { static: false } ) cdTimer: CdTimerComponent;

  constructor(private serverService: ServerService, private router:Router) {
    

   }
  websocket;
  socketData;
  user_type;
  loginUser;
  show_act_wall = false;
has_admin =false;
has_user =false;
admin_id;
has_hard_id;
countupTimerService;
onCall;
testConfig;
queuesDatas;
agentsDatas;
availDatas;
makebusyDatas;
outgoingDatas;
logoutDatas;
data;
queueData;
addagentsData;
doc_link;
call_waiting=0;
aval_agents=0;
aget_busy=0;
wait_time=0;
overAl_SLA=0;
total=0;
overAl_SLA_percent=0;

answered=0;
abandoned=0;
talktime=0;
aband_percent=0;
tot_make_busy=0;
answer_percent=0;
long_wait_time=0;
oncall_data=0;
available_data=0;
outgoing_data=0;
makebusy_data=0;
// logged_queues=0;
  ngOnInit(): void {
    

 // this.countupTimerService.startTimer();
//  this.cdTimer.start();
    this.user_type = localStorage.getItem('user_type');
    this.loginUser = localStorage.getItem('userId');
    this.admin_id = localStorage.getItem('admin_id');
    
    this.user_type = localStorage.getItem('user_type');
    if(this.user_type == 'Admin'){
      this.has_admin = true;
    } else {
      this.has_user = true;
    }
  
    this.has_hard_id = localStorage.getItem('hardware_id');
    if(this.has_hard_id == ""){
        $("#addLicence").modal({"backdrop": "static"});
        this.show_act_wall = true;
    } else {
      this.checkLicenseKey();
  }
  


}

startTimer (){
 
}


initSocket() {
  
  this.user_type = localStorage.getItem('user_type');
  this.loginUser = localStorage.getItem('userId');  

  if(this.admin_id == '64'){
    this.websocket = new WebSocket("wss://myscoket.mconnectapps.com:4002"); 
  } else if(this.admin_id == '201'){
    this.websocket = new WebSocket("wss://myscoket.mconnectapps.com:4003"); 
  } else {
    this.websocket = new WebSocket("wss://myscoket.mconnectapps.com:4001"); 
  }


  this.websocket.onopen = function(event) { 
    $('#sendonload').click();
    console.log('socket connected');
  }

  this.websocket.onmessage = function(event) {
    console.log(event.data);
 
    var result_message: any = JSON.parse(event.data);
 
  //  console.log(result_message);
    this.has_hard_id = localStorage.getItem('hardware_id');
    if(result_message.cust_id == this.has_hard_id || result_message[0].cust_id == this.has_hard_id){
      console.log('matched');
    } else {
      console.log('not matched');
      return false;
    }



    if(result_message[0].data[0].type!=undefined){
      $('#mrVoipType').val(event.data); 
      $('#mrVoipType').click();
    }
      // else if(result_message[0].data[0].status=="oncall"){        
      //           if(result_message[0].data[0].Type=="end"){
      //                 $('#removeoncall').val(result_message[0].data[0].agent_no); 
      //                 $('#removeoncall').click();
      //           }
      //           else{
      //                 $('#onCallData').val(event.data); 
      //                 $('#onCallData').click();}
      // } 
      // else if(result_message[0].data[0].status=="available"){
      //           if(result_message[0].data[0].Type=="end"){
      //             $('#removeavailable').val(result_message[0].data[0].agent_no); 
      //             $('#removeavailable').click();
      //       }else{
      //           $('#availData').val(event.data); 
      //           $('#availData').click();}
      // } 
      // else if(result_message[0].data[0].status=="makebusy"){
      //           if(result_message[0].data[0].Type=="end"){
      //             $('#removemakebusy').val(result_message[0].data[0].agent_no); 
      //             $('#removemakebusy').click();
      //       }else{
      //           $('#makebusyData').val(event.data); 
      //           $('#makebusyData').click();}
      // } 
      //  else if(result_message[0].data[0].status=="outgoing"){
      //           if(result_message[0].data[0].Type=="end"){
      //             $('#removeoutgoing').val(result_message[0].data[0].agent_no); 
      //             $('#removeoutgoing').click();
      //       }else{
      //           $('#outgoingData').val(event.data); 
      //           $('#outgoingData').click();}
      // }
      else if(result_message[0].data[0].status=="logout"){
                  if(result_message[0].data[0].Type=="end"){
                    $('#removelogout').val(result_message[0].data[0].agent_no); 
                    $('#removelogout').click();
              }else{
                        $('#logoutData').val(event.data); 
                        $('#logoutData').click();}
            }
      else if(result_message[0].data[0].ano!=undefined){
        $('#agentsData').val(event.data); 
        $('#agentsData').click();
      }
      else if(result_message[0].data[0].qno!=undefined){
        $('#queuesData').val(event.data); 
        $('#queuesData').click();
      }
      else if(result_message[0].data[0].queue_name!=undefined){
        $('#ques_list').val(event.data); 
        $('#ques_list').click();
      }
      else if( result_message[0].data[0].logged_queues!=undefined){
        // $('#logged_queues').val(event.data); 
        // $('#logged_queues').click();
      }
      else if(result_message[0].data[0].agent_name!=undefined){
        $('#agent_list').val(event.data); 
        $('#agent_list').click();
      } 
      else if(result_message[0].data[0].single_queue!=undefined){
        $('#single_queue').val(event.data); 
        $('#single_queue').click();
      } 
      else if( result_message[0].data[0].single_agent!=undefined){
        $('#single_agent').val(event.data); 
        $('#single_agent').click();
      } 
      
     else {
      
    }  
    
  }
  this.websocket.onerror = function(event){
    console.log('error');
  }
  this.websocket.onclose = function(event){
    console.log('close');
    console.log('Socket Disconnected.Reconnection will be attempted');
    $('#reconnect_socket').click();
  } 

  
  
}

ngOnDestroy(): void {
  //Called once, before the instance is destroyed.
  //Add 'implements OnDestroy' to the class.
 
}
deleteRow(qry,data){
         var r_id= $('#'+qry).val();        
  for(let i = 0; i < data.length; ++i){
      if (data[i].agent_no === r_id) {
            data.splice(i,1);
      }
  }
}
// deleteRow(d){
//   alert(d);  
//   const index = this.onCall.indexOf(d);
  
//   this.onCall.splice(index, 1);
// }

sendOnload(){
  // var socket_message  =  '[{"Name":"onload"}]';
  var socket_message  = '[{"cust_id":"'+this.has_hard_id+'","data":[{"Name":"onload","Type":"advance_wallboard_5"}]}]' ;
  this.websocket.send(socket_message);
}
reloadQueue(){
  Swal.fire({
    title: 'Are you sure?',
    text: "This will reset the Wallboard. You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Reset!'
  }).then((result) => {
    if (result.value) {
      var socket_message  =  '[{"cust_id":"'+this.has_hard_id+'","data":[{"Name":"reset"}]}]';
  this.websocket.send(socket_message);
    }
  });
}
onCallData(){
  let socketData = $('#onCallData').val();
  let mData = JSON.parse(socketData);
  this.onCall = mData[0].data;
  console.log(this.onCall);
}

availData(){
  let socketData = $('#availData').val();
  let mData = JSON.parse(socketData);
  this.availDatas = mData[0].data;
  console.log(this.availDatas);
}
makebusyData(){
  let socketData = $('#makebusyData').val();
  let mData = JSON.parse(socketData);
  this.makebusyDatas = mData[0].data;
  console.log(this.makebusyDatas);
}
outgoingData(){
  let socketData = $('#outgoingData').val();
  let mData = JSON.parse(socketData);
  this.outgoingDatas = mData[0].data;
  console.log(this.outgoingDatas);
}
logoutData(){
  let socketData = $('#logoutData').val();
  let mData = JSON.parse(socketData);
  this.logoutDatas = mData[0].data;
  console.log(this.logoutDatas);
}



agentsData(){
  let socketData = $('#agentsData').val();
  let mData = JSON.parse(socketData);
  this.agentsDatas = mData[0].data;
  console.log(this.agentsDatas);
}

queuesData(){
  let socketData = $('#queuesData').val();
  let mData = JSON.parse(socketData);
  this.queuesDatas = mData[0].data;
  console.log(this.queuesDatas);
}

checkLicenseKey(){
  let access_token: any=localStorage.getItem('access_token');

  let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"check_hardware","user_id":"'+this.loginUser+'"}}';
  this.serverService.sendServer(api_req).subscribe((response:any) => {
    if(response.result.data.value=='1'){
      this.initSocket();            
    } else {
      iziToast.error({
        message: "Your Licence Key is expired!.. please enter your key or contact admin",
        position: 'topRight'
        });
        $("#addLicence").modal({"backdrop": "static"});
        this.show_act_wall = true;
    }
  }, 
  (error)=>{
      console.log(error);
  });
}




single_queue(){
  let socketData = $('#single_queue').val(); 
  let mData = JSON.parse(socketData);
  var single_queue = mData[0].data;

  var qname = single_queue[0].single_queue+'_queue_name';
  var callwaiting= single_queue[0].single_queue+'_callwaiting';
  var lng_callwaiting = single_queue[0].single_queue+'_lng_callwaiting';
  var totalcall = single_queue[0].single_queue+'_totalcall';
  var answerd = single_queue[0].single_queue+'_answerd';
  var missed = single_queue[0].single_queue+'_missed';
  var sla_per = single_queue[0].single_queue+'_sla_per';

  

  $('#'+qname).html(single_queue[0].single_queue_name);
  $('#'+callwaiting).html(single_queue[0].callwaiting);
  $('#'+lng_callwaiting).html(single_queue[0].lng_callwaiting);
  $('#'+totalcall).html(single_queue[0].totalcall);
  $('#'+answerd).html(single_queue[0].answerd);
  $('#'+missed).html(single_queue[0].missed);
  // $('#'+sla_per).html(single_queue[0].sla_per);

  $('#'+sla_per).html('<span>'+single_queue[0].sla_per+'%</span><div class="progress progress-thin"><div class="progress-bar progress-bar-green" style="width: '+single_queue[0].sla_per+'%;"  ></div></div>');

 
}



single_agent(){
  let socketData = $('#single_agent').val(); 
  let mData = JSON.parse(socketData);
  var single_agent = mData[0].data;
  console.log(single_agent);
  console.log(single_agent[0].single_agentno);

  var aname = single_agent[0].single_agentno+'_agentname';
  var avg_talking= single_agent[0].single_agentno+'_avg_talking';
  var avgoutbound = single_agent[0].single_agentno+'_avgoutbound';
  var missed = single_agent[0].single_agentno+'_missed';
  var answerd = single_agent[0].single_agentno+'_answerd';
  var state = single_agent[0].single_agentno+'_state';
  var statetime = single_agent[0].single_agentno+'_statetime';
  var totoutbound = single_agent[0].single_agentno+'_totoutbound';
  

  $('#'+aname).html(single_agent[0].single_agent);
  $('#'+avg_talking).html(single_agent[0].avg_talking);
  // $('#'+avgoutbound).html(single_agent[0].avgoutbound);
  $('#'+missed).html(single_agent[0].missed);
  // $('#'+answerd).html(single_agent[0].answerd);
  $('#'+state).html('<span>'+single_agent[0].state+'</span>');
  $('#'+statetime).html(single_agent[0].statetime);
  $('#'+totoutbound).html(single_agent[0].totoutbound);
  
  

  $('#'+avgoutbound).html('<span>'+single_agent[0].avgoutbound+'%</span><div class="progress progress-thin"><div class="progress-bar progress-bar-green" style="width: '+single_agent[0].avgoutbound+'%;"  ></div></div>');

 $('#'+answerd).html('<span>'+single_agent[0].answerd+'</span>');

 if(single_agent[0].state == 'Available'){
  $('#'+state).html('<span style="width:11px" class="presence available"></span>Available');
} else if(single_agent[0].state == 'Away'){
  $('#'+state).html('<span style="width:11px" class="presence away"></span>Away');
} else if(single_agent[0].state == 'Out of office'){
  $('#'+state).html('<span style="width:11px" class="presence out_of_office"></span>Out of office');
} else if(single_agent[0].state == 'Custom 1'){
  $('#'+state).html('<span style="width:11px" class="presence wash-room"></span>Custom 1');
} else if(single_agent[0].state == 'Custom 2'){
  $('#'+state).html('<span style="width:11px" class="presence meeting"></span>Custom 2');
} else if(single_agent[0].state == 'Busy'){
  $('#'+state).html('<span style="width:11px" class="presence busy"></span>Busy');
}
else if(single_agent[0].state == 'AUX'){
  $('#'+state).html('<span style="width:11px" class="presence out_of_office"></span>AUX');
}




}




addQueue(){
  $('#addQueue').modal('show');
}



changeData(){
  let socketData = $('#ques_list').val(); 
  let mData = JSON.parse(socketData);
  this.queueData = mData[0].data;
}

getQueues(){
  var mainQueues = $('.queues_check:checked').map(function(){
    return this.value;
}).get();


if(mainQueues == ''){

  iziToast.warning({
    message: "Please Select Atleast One",
    position: 'topRight'
});
  return false;
}
this.has_hard_id = localStorage.getItem('hardware_id');
 mainQueues = '[{"cust_id":"'+this.has_hard_id+'","data":['+mainQueues.join()+']}]';
//  alert(mainQueues);
 console.log(mainQueues);
 this.websocket.send(mainQueues);
 $('#addQueue').modal('hide');
}

addUsers(){
  $('#addUsers').modal('show');
}

changeAgents(){
  let socketData = $('#agent_list').val(); 
  let mData = JSON.parse(socketData);
  this.addagentsData = mData[0].data;
}

getQueUsers(){
  var mainAgents = $('.agents_check:checked').map(function(){
    return this.value;
}).get();


if(mainAgents == ''){

  iziToast.warning({
    message: "Please Select Atleast One",
    position: 'topRight'
});
  return false;
}
this.has_hard_id = localStorage.getItem('hardware_id');

mainAgents = '[{"cust_id":"'+this.has_hard_id+'","data":['+mainAgents.join()+']}]';

 this.websocket.send(mainAgents);
 $('#addUsers').modal('hide');
}

 
slectAllQue(){
  if($("#selectAllQ").prop("checked")) {
    $(".queues_check").prop("checked", true);
} else {
    $(".queues_check").prop("checked", false);
} 
}

slectunique(){
	$("#selectAllQ").prop("checked",false)
  }

slectAllagent(){
  if($("#slectAllagent").prop("checked")) {
    $(".agents_check").prop("checked", true);
} else {
    $(".agents_check").prop("checked", false);
} 
}
slectuniqueagent(){
	$("#slectAllagent").prop("checked",false)
  }


  // manageCallQueue(){
  //   $('#manageCallQueue').modal('show');
  // }
  

  // loggedQueues(){
  //   let socketData = $('#logged_queues').val(); 
  //   let mData = JSON.parse(socketData);
  //   this.logged_queues = mData[0].data;
  // }

  showdoc(link){   
    this.doc_link=link;
   $("#document_model").modal('show');   
  }
  changeWallType(){

    let socketData = $('#mrVoipType').val(); 
    let mData = JSON.parse(socketData);
    this.socketData = mData[0].data[0];
  
    if(this.socketData.type =="awb5_waiting"){  
      this.call_waiting=this.socketData.value;
    }
    else if(this.socketData.type =="awb5_avlagent"){
     this.aval_agents= this.socketData.value;
    }
    else if(this.socketData.type =="awb5_agentbusy"){
      this.aget_busy=this.socketData.value;
    }
    else if(this.socketData.type =="awb5_waitingtime"){
      this.wait_time=this.socketData.value;
     }
    else if(this.socketData.type =="awb5_overallsla"){
         this.overAl_SLA=this.socketData.value;
     }
     else if(this.socketData.type =="awb5_overallslaper"){
      this.overAl_SLA_percent=this.socketData.value;
  }
    else if(this.socketData.type =="awb5_total"){
      this.total =this.socketData.value;
    }
    else if(this.socketData.type =="awb5_answered"){
      this.answered =this.socketData.value;
    }
    else if(this.socketData.type =="awb5_abandoned"){
      this.abandoned =this.socketData.value;
    }
    else if(this.socketData.type =="awb5_talktime"){
      this.talktime =this.socketData.value;
    } 
    else if(this.socketData.type =="awb5_perabandoned"){
      this.aband_percent =this.socketData.value;
    }
    else if(this.socketData.type =="awb5_totmakebusy"){
      this.tot_make_busy =this.socketData.value;
    }
    else if(this.socketData.type =="awb5_peranswered"){
      this.answer_percent =this.socketData.value;
    }
    else if(this.socketData.type =="awb5_lngwaitingtime"){
      this.long_wait_time =this.socketData.value;
    }    
    else if(this.socketData.type =="oncall"){
      this.oncall_data =this.socketData.value;
    } 
    else if(this.socketData.type =="available"){
      this.available_data =this.socketData.value;
    }
    else if(this.socketData.type =="outgoing"){
      this.outgoing_data =this.socketData.value;
    }
    else if(this.socketData.type =="makebusy"){
      this.makebusy_data =this.socketData.value;
    }
  
  }
  fullWindow(){
    var element = document.getElementById("wallboardFullPanel");
    element.classList.toggle("fullSize");
    }
  
}

